import { useNavigate } from 'react-router-dom'

import GamingSelectionTemplate from '@/components/templates/gamingSelection/gamingSelectionTemplate'

export default function GamingSelectionPage() {
    const navigate = useNavigate()

    return <GamingSelectionTemplate navigate={navigate} />
}
